import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ImageModel } from '../models/image.model';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  public selected: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public imagesChanged: EventEmitter<ImageModel[]> = new EventEmitter<ImageModel[]>();
  public images: ImageModel[] = [];

  public deleteImage(id: string) {
    let index = this.images.findIndex(i => i.id === id);
    if (index > -1) {
      this.images.splice(index, 1);
      this.imagesChanged.emit(this.images);
    }
  }

  public uploadImage(data: ImageModel) {
    data.id = '00000000-0000-0000-0000-000000000000';
    this.images.push(data);
    this.imagesChanged.emit(this.images);
  }
}
